<template>
  <v-container fluid>
    <div>
      <v-row style="min-height:608px;" class="mt-2">
        <div
            class="bordered mr-2 rounded-4 fixed-height"
            style="border-right: 1px solid rgba(0, 0, 0, 0.12); width: 25%; background: white"
        >
          <v-subheader v-if="chatRoomsList.length == 0"
          >No chats present
          </v-subheader
          >
          <div class="justify-center align-center w-full top-rounded-4" v-else>
            <v-text-field
                prepend-inner-icon="mdi-magnify"
                v-model="searchChat"
                class="q-text-field shadow-0 pa-4"
                dense
                outlined
                hide-details
                placeholder="Search chat"
            ></v-text-field>
          </div>
          <v-list-item-group shaped mandatory v-model="user">
            <template v-for="item in filteredChatList">
              <v-list-item :key="item.id" :value="item.id" class="border-bottom">
                <v-list-item-avatar>
                  <v-img v-if="item.user.profile_image" :src="s3BucketURL + item.user.profile_image"></v-img>
                  <v-img v-else src="./../../../assets/images/profile_blank.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.user.name }}</v-list-item-title>
                  <v-list-item-title class="caption">{{
                      item.last_message.message
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </div>
        <div
            class="bordered mr-2 rounded-4 fixed-height"
            style="border-right: 1px solid rgba(0, 0, 0, 0.12); width: 70%; background: white"
        >
          <v-container class="chatList overflow-y-auto">
            <v-row
                v-if="chatRoomsList.length == 0"
                align="center"
                justify="center"
            >
              <v-card tile flat class="pa-2 mt-2 mr-6">No chats present</v-card>
            </v-row>
            <div v-else>
              <template v-for="data in chatList">
                <v-row
                    v-if="data.is_my_message == true"
                    align="center"
                    justify="end"
                    :key="data.id"
                >
                  <div class="d-flex align-center gap-x-1" style="width:fit-content; max-width: 80%">
                    <span class="text-xs text-right time-stamp"> {{
                        data.created_at | timeStamp
                      }}</span>
                    <div class="pa-4 mt-2 mr-6 bordered chat-bubble-rounded-my">
                      <p class="chat-text">{{
                          data.message
                        }}</p>
                    </div>
                  </div>
                </v-row>
                <v-row v-else align="center" justify="start" :key="data.id">
                  <div class="d-flex flex-column gap-y-1 m-t-5">
                    <div class="d-flex justify-start align-center">
                      <v-list-item-avatar class="text-left align-self-start m-y-0 m-l-0">
                        <v-img v-if="data.profile_image" :src="s3BucketURL + data.profile_image"></v-img>
                        <v-img v-else src="./../../../assets/images/profile_blank.png"></v-img>
                      </v-list-item-avatar>
                      <span class="user-details">{{
                          data.name
                        }}</span>
                      <span class="text-xs ml-2 time-stamp"> {{
                          data.created_at | timeStamp
                        }}</span>
                    </div>
                    <div class="pa-4 mr-6 bordered chat-bubble-rounded ml-12"
                         style="width:fit-content; max-width: 80%; background: #112A461A;">
                      <p class="chat-text">{{
                          data.message
                        }}</p>
                    </div>

                  </div>
                </v-row>
              </template>
            </div>
          </v-container>
        </div>
      </v-row>
    </div>
  </v-container>
</template>

<script>
// import DefaultUserImage from '@/assets/images/profile_blank.png'
export default {
  // components: {
  //   DefaultUserImage
  // },
  data() {
    return {
      searchChat: '',
      user: null,
      chatRoomsList: [],
      chatList: [],
      filteredChatList: [],
    };
  },
  props: {
    userID: {type: Number},
  },
  mounted() {
    this.getChatUsers();
  },
  watch: {
    userID() {
      this.chatRoomsList = [];
      this.chatList = [];
      this.getChatUsers();
    },
    user(val) {
      this.getChatList(val);
    },
    chatList() {
      setTimeout(() => this.scrollToBottom(), 500);
    },
    searchChat() {
      this.filteredChatList = this.chatRoomsList.filter((item) => {
        return this.searchChat ? item.user.name.toLowerCase().includes(this.searchChat.toLowerCase()) : true;
      });
    }
  },
  methods: {
    getChatUsers() {
      this.showLoader('Loading');
      this.$http
          .get("admin/chats?user_id=" + this.userID)
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.chatRoomsList = response.data.data;
              this.filteredChatList = this.chatRoomsList;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          }).finally(() => {
        this.hideLoader()
      });
    },
    getChatList(id) {
      this.showLoader('loading chat');
      if (id == null) return;
      this.$http
          .get(
              "admin/chats/details?user_id=" + this.userID + "&chat_room_id=" + id
          )
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.chatList = response.data.data;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          }).finally(() => {
        this.hideLoader()
      });
    },
    scrollToBottom() {
      const el = this.$el.getElementsByClassName("chatList")[1];
      el.scrollTop = el.scrollHeight;
    },
  },
};
</script>

<style>

.top-rounded-4 {
  border-radius: 1rem 1rem 0 0 !important;
}

.chat-bubble-rounded {
  border-radius: 0 1.5rem 1.5rem 1.5rem !important;
}

.chat-bubble-rounded-my {
  border-radius: 1.5rem 1.5rem 0 1.5rem !important;
}

.fixed-height {
  height: calc(100vh - 200px);
  overflow: auto;
}

.user-details {
  font-size: 12px;
  font-weight: 600;
  line-height: 14.52px;
  text-align: left;
  color: #112A46;
}

.time-stamp {
  color: #00000066;
}

.chat-text{
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  margin-bottom: 0 !important;
}
</style>
